import { Injectable } from '@angular/core';
import { AbstractResetAccountService } from './abstract-resetAcountService';
import { UserModel } from '../../../shared/model/userModel';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class ResetAccountService implements AbstractResetAccountService {

  constructor(private http: HttpClient) { }

  resetAccount(userModel: UserModel): Observable<any>{
      const url = environment.apiBaseUrl + 'logon/resetAccount';
      const userData = JSON.stringify(userModel);
      const headers = new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json');
  
      return this.http.post<any>(url, userData, { headers: headers });
    }

}


// WEBPACK FOOTER //
// ./src/app/account/resetAccount/services/resetAccount.service.ts